var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4e5e9c;}.cls-2{fill:#5d72ae;}.cls-3{fill:#c6668f;}.cls-4{fill:#da8ab3;}.cls-5,.cls-6{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:10px;}.cls-5{stroke-linecap:round;}.cls-7{fill:#2b3160;}.cls-8{fill:#37417d;}.cls-9{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artificial Intelligence") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BULINE"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 256
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.07,86.75A192,192,0,0,1,298.75,270a192.5,192.5,0,0,1-42.56,4.74l-2.54,0a191.16,191.16,0,0,1-128.77-51.94A193.07,193.07,0,0,1,91,180.54,190.81,190.81,0,0,1,64.32,86.31a256,256,0,0,1,383.75.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M494.63,259.68a62,62,0,0,1-62,62h-357v-.41a62,62,0,0,1,5.16-123.51,69.09,69.09,0,0,1,63.92-42.88,70.08,70.08,0,0,1,10.41.78,90.51,90.51,0,0,1,169.1-24c.87,0,1.72-.07,2.6-.07a95.07,95.07,0,0,1,91.09,67.9,62,62,0,0,1,76.72,60.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M494.63,259.68a62,62,0,0,1-62,62H142.39a62,62,0,0,1,25.09-117.72,69.09,69.09,0,0,1,63.92-42.88,70.11,70.11,0,0,1,10.42.78,90.6,90.6,0,0,1,51.05-64.61,91.14,91.14,0,0,1,31.35,34.41c.87,0,1.72-.07,2.6-.07a95.07,95.07,0,0,1,91.09,67.9,62,62,0,0,1,76.72,60.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 253.65,
    y1: 167.34,
    x2: 253.65,
    y2: 130.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 282.68,
    y1: 166.8,
    x2: 282.68,
    y2: 130.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 222.02,
    y1: 166.8,
    x2: 222.02,
    y2: 130.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 299.75,
    y1: 218.33,
    x2: 336.41,
    y2: 218.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 300.29,
    y1: 247.36,
    x2: 336.96,
    y2: 247.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 300.29,
    y1: 186.69,
    x2: 336.96,
    y2: 186.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 170.08,
    y1: 218.33,
    x2: 206.75,
    y2: 218.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 170.62,
    y1: 247.36,
    x2: 207.29,
    y2: 247.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 170.62,
    y1: 186.69,
    x2: 207.29,
    y2: 186.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 210.68,
    y1: 257.51,
    x2: 210.68,
    y2: 400.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 298.75,
    y1: 257.51,
    x2: 298.75,
    y2: 400.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 253.65,
    y1: 269.05,
    x2: 253.65,
    y2: 464.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 202.17,
    y: 165,
    width: 104.05,
    height: 104.05,
    rx: 16.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 213.71,
    y: 176.54,
    width: 80.97,
    height: 80.97,
    rx: 16.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.8,236l-12.64-40.3a7.05,7.05,0,0,0-6.73-4.94h-5.89a7.05,7.05,0,0,0-6.74,5L219.36,236a3.78,3.78,0,0,0,3.62,4.9h4.56a3.78,3.78,0,0,0,3.62-2.68l2.2-7.2H246.8l2,7.14a3.77,3.77,0,0,0,3.64,2.74h7.7A3.78,3.78,0,0,0,263.8,236ZM236,220.08,240,205.52l4.06,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M280.55,190.75h-5.77a4.81,4.81,0,0,0-4.81,4.81V236.1a4.81,4.81,0,0,0,4.81,4.81h5.77a4.81,4.81,0,0,0,4.82-4.81V195.56A4.81,4.81,0,0,0,280.55,190.75Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 210.68,
    y1: 350.8,
    x2: 156.68,
    y2: 350.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 352.75,
    y1: 350.8,
    x2: 298.75,
    y2: 350.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 142.68,
    cy: 350.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 210.68,
    cy: 409.13,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 253.65,
    cy: 478.47,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 298.75,
    cy: 410.8,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 363.15,
    cy: 350.8,
    r: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.726f4d71e3d0a4aed6865df8272a4d30.svg";
export { ForwardRef as ReactComponent };